/**
 * Pack « Éveil NG+ » post-ascension — burst or + élan de route.
 */

export const ASCENSION_POST_BOOST_MS = 24 * 60 * 60 * 1000
export const ASCENSION_POST_BOOST_MULT = 1.25

export const ASCENSION_BURST_GOLD_MS = 2 * 60 * 60 * 1000
export const ASCENSION_BURST_GOLD_MULT = 2

export const ASCENSION_ROUTE_SURGE_MS = 2 * 60 * 60 * 1000
/** Kills par palier × ce facteur dans les zones gen ≤ ROUTE_SURGE_MAX_GEN. */
export const ASCENSION_ROUTE_SURGE_KILLS_MULT = 0.5
export const ASCENSION_ROUTE_SURGE_MAX_GEN = 3

export function isAscensionBurstGoldActive(untilMs: number, nowMs = Date.now()): boolean {
  const until = Math.max(0, Math.floor(Number(untilMs) || 0))
  return until > nowMs
}

export function isAscensionRouteSurgeActive(
  untilMs: number,
  generation: number,
  nowMs = Date.now(),
): boolean {
  const until = Math.max(0, Math.floor(Number(untilMs) || 0))
  if (until <= nowMs) return false
  return Math.max(1, Math.floor(Number(generation) || 1)) <= ASCENSION_ROUTE_SURGE_MAX_GEN
}
